.header-base-wrapper {
  background-color: $color-white;
  position: relative;
  z-index: 1;
  height: var(--header-height);
  display: grid;
  grid-auto-flow: column;
  grid-template-columns:
    [burger-start] 56px [burger-end] 16px [logo-start] 1fr [logo-end search-start] var(
      --header-height
    )
    [search-end];

  @include media-min(md) {
    grid-template-columns:
      [burger-start] 80px [burger-end] 32px [logo-start] 1fr [logo-end meta-start] auto [meta-end] 48px [search-start] var(
        --header-height
      )
      [search-end];
  }

  @include media-min(xl) {
    grid-template-columns: 32px [logo-start] 1fr [logo-end meta-start] auto [meta-end] 48px [search-start] 22% [search-end];
  }

  @include media-min(xl) {
    position: relative;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: $color-grey-01;
      z-index: 1;
    }
  }
}

.burger-wrapper {
  grid-column: burger;

  @include media-min(xl) {
    display: none;
  }
}

.logo-wrapper {
  grid-column: logo;
  display: flex;
  align-items: center;
}

.meta-nav-wrapper {
  grid-column: meta;
  align-items: center;
  padding-block: 8px;
  grid-auto-flow: column;
  gap: 32px;
  display: none;

  @include media-min(md) {
    display: grid;
  }
}

.search-wrapper {
  grid-column: search;
  display: flex;
  align-items: center;
  z-index: 2;
}
